import { render, staticRenderFns } from "./FormSpinbutton.vue?vue&type=template&id=5255655e&"
import script from "./FormSpinbutton.vue?vue&type=script&lang=js&"
export * from "./FormSpinbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports